import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import * as dayjs from 'dayjs';
import { DateObjectToYYYMMDDstring } from 'src/app/product-capture/utils/convert-date-object-to-yyyy-mm-dd-string';

export function tradingDayValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const dateObj = control.value;
    const dateStr = DateObjectToYYYMMDDstring(dateObj);
    const dayIndex = dayjs(dateStr).day(); // NB. index runs 0 (Sunday) - 6 (Saturday)

    if (dayIndex === 0 || dayIndex === 6) {
      return { incorrect: true, message: 'Please enter a valid trading day' };
    }

    return null;
  };
}
